export const systemAndProviderInformation = {
  title: 'System and Provider Information',
  fields: [
    {
      label: 'AI System type / category',
      placeholder: 'Enter AI system type',
    },
    {
      label: 'Unique reference / traceability ID',
      placeholder: 'Enter reference or ID',
    },
    {
      type: 'textArea',
      label: 'Intended purpose & context of use',
      placeholder:
        'e.g. embedded software, downloadable package, SaaS/API, mobile or desktop application',
    },
    {
      label: 'Registered trade name / trademark (if any)',
      placeholder: 'Enter trade name or trademark',
    },
    {
      label: 'Registered address (street, city, country)',
      placeholder: 'Enter address',
    },
    {
      type: 'email',
      label: 'Contact',
      placeholder: 'Enter email',
    },
    {
      label: 'Authorised representative in the EU (if applicable)',
      placeholder: 'Authorised representative name',
      optionalForInternal: true,
    },
    {
      label: 'Authorised representative address',
      placeholder: 'Enter address',
      optionalForInternal: true,
    },
  ],
};

export const notifiedBodyConformityAssessment = {
  title: 'Notified Body & Conformity Assessment',
  fields: [
    {
      label: 'Notified body name (if notified body involved)',
      placeholder: 'Enter notified body name',
    },
    {
      label: 'Notified body identification number (if notified body involved)',
      placeholder: 'Enter identification number',
    },
    {
      type: 'textArea',
      label: 'Conformity assessment procedure performed',
      placeholder: 'Describe the conformity assessment procedure performed',
    },
    {
      type: 'textArea',
      label: 'Certificate identification',
      placeholder: 'Enter certificate identification e.g. number, date, scope',
    },
  ],
};

export const conformityStatement = [
  {
    label: 'Union act / instrument',
    placeholder: 'Enter union act or instrument',
  },
  {
    label: 'Scope / subject',
    placeholder: 'Enter scope or subject',
  },
  {
    label: 'Reference(s)',
    placeholder: 'Enter reference',
  },
];

export const harmonisedStandards = [
  {
    label: 'Identifier',
    placeholder: 'Enter identifier',
  },
  {
    label: 'Title',
    placeholder: 'Enter title',
  },
  {
    label: 'Applied aspects / clauses',
    placeholder: 'Enter aspects or clauses',
  },
];

export const personalDataComplianceOptions = [
  {
    label:
      'The AI system involves processing of personal data. In such case, the provider declares compliance with Regulations (EU) 2016/679 and (EU) 2018/1725 and Directive (EU) 2016/680.',
    value:
      'The AI system involves processing of personal data. In such case, the provider declares compliance with Regulations (EU) 2016/679 and (EU) 2018/1725 and Directive (EU) 2016/680.',
  },
  {
    label: 'Not applicable (no personal data is processed by the AI system).',
    value: 'Not applicable (no personal data is processed by the AI system).',
  },
];
